export default "__VITE_PUBLIC_ASSET__7e8e3fb5__"